import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import { required, email} from "vuelidate/lib/validators";

const file_size_validation = (value, vm) => {
  if (!value || !value.size) {
    return true;
  }
  let file = value;
  return file.size < 1048576;
};
const image_type_validation = (value, vm) => {
  if (!value || !value.size) {
    return true;
  }
  let file = value;
  if (
    file.type == "image/svg+xml" ||
    file.type == "image/jpeg" ||
    file.type == "image/gif" ||
    file.type == "image/png"
  ) {
    return true;
  } else {
    return false;
  }
};
  
  export default {
    components: {
    },
    data() {
      return {
        ShowLoader: false,
        Saving: false,
        submitted: false,
        SearchKey: "",
        UserId:0,
        ProfileImage:"",
        Branches: [],
        Roles: [],
        updateAccountRole:false,
        EditUser: {
          forename: "",
          surname: "",
          email: "",
          phone: "",
          profile_image: "",
          role_id: "",
          branch_ids: [],
        },
      };
    },
    validations: {
      EditUser: {
        forename: { required },
        surname: { required },
        email: { required, email },
        phone: { required },
        profile_image: { file_size_validation, image_type_validation },
        role_id: { required },
      },
    },
    mounted() {
      document.title = pbx_SiteTitle + " - User Add";
      this.UserId = this.$route.params.UserId;
      this.GetUserDetail();
      this.GetBranches();
      this.GetRoles();
      var LoginUser = JSON.parse(
        localStorage.getItem("User"));
        if(LoginUser.id == this.UserId){
          this.updateAccountRole = true;
        }
    },

    methods: {
      GetBranches() {
        var obj = { token: localStorage.getItem("token"), select_branch: true };
        Axios.post(Endpoints.Branch.List, obj).then((Response) => {
          if (Response.data.success) {
            this.Branches = Response.data.records;
          }
        });
      },
      GetRoles() {
        var obj = { token: localStorage.getItem("token") };
        Axios.post(Endpoints.Roles.List, obj).then((Response) => {
          if (Response.data.success) {
            this.Roles = Response.data.records;
          }
        });
      },
      GetUserDetail() {
        this.ShowLoader = true;
        Axios.post(Endpoints.User.Get, {
          token: localStorage.getItem("token"),
          id: this.UserId,
        }).then((Response) => {
          this.ShowLoader = false;
          if (Response.data.success) {
            this.EditUser = Response.data.record;
            if(this.EditUser.role_id == 1){
                this.updateAccountRole = true;
            }
            this.GetProfileImage(this.EditUser.profile_image);
          }
        });
      },
      imageFileChanged(event) {
        var files = event.target.files || event.dataTransfer.files;
        if (!files.length) {
          return;
        }
        this.EditUser.profile_image = files[0];
        var output = document.querySelector(".icon__preview");
        output.src = URL.createObjectURL(files[0]);
        output.onload = function () {
          URL.revokeObjectURL(output.src); // free memory
        };
      },
      UpdateUser() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.Saving = true;
        Axios.post(Endpoints.User.Update, {
          token: localStorage.getItem("token"),
          ...this.EditUser,
        }).then((Response) => {
          if (Response.data.success) {
            this.UpdateProfileImage(Response.data.last_id);
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response.data.message,
              icon: "error",
              confirmButtonText: "Close",
            });
            this.Saving = false;
          }
        });
      },
      UpdateProfileImage(id) {
        var LogoFormData = new FormData();
        if (this.$refs.ProfileImageFile.files[0]) {
          LogoFormData.append("storage_type", "CFU");
          LogoFormData.append("token", localStorage.getItem("token"));
          LogoFormData.append("file", this.$refs.ProfileImageFile.files[0]);
          LogoFormData.append(
            "company_id",
            this.EditUser.company_id
          );
          LogoFormData.append("user_id", id);
          Axios.post(Endpoints.Helper.File.Upload, LogoFormData).then(
            (UploadResponse) => {
              var UploadData = UploadResponse.data;
              if (UploadData.success === true) {
                Axios.post(Endpoints.User.Profile.Image.Set, {
                  token: localStorage.getItem("token"),
                  profile_image: UploadData.file,
                  id: id,
                }).then((SetResponse) => {
                  this.$swal.fire(
                    "User Updated Successfully",
                    "",
                    "success"
                  ).then(() => {
                    this.$router.push(
                      "/users/"
                    );
                  });
                });
              }
            }
          );
        } else {
          this.$swal.fire("User Updated Successfully", "", "success").then(
            () => {
              this.$router.push(
                "/users/"
              );
            }
          );
        }
      },
      GetProfileImage(profileImage) {
        Axios.post(Endpoints.Helper.File.Get, {
          token: localStorage.getItem("token"),
          file: profileImage,
        }).then((FileGetResponse) => {
          var FileData = FileGetResponse.data;
          if (FileData.success === true) {
            this.ProfileImage = FileData.file;
            this.$refs.editProfileImagePreview.src = FileData.file;
          }
        });
      },
    },
  };